export default __webpack_public_path__ + "static/media/Beard_9_C4.e1f1599f.svg";